export const HOME_PATH = '/';
export const GLOBAL_IMPACT_PATH = '/impact';
export const TRENDS_PATH = '/trends';
export const BREAKDOWN_PATH = '/breakdown';
export const FACTSHEETS_PATH = '/factsheets';
export const ABOUT_PATH = '/about';
export const HIV_PATH = 'https://hiv.ihme.services';
